import { render, staticRenderFns } from "./TotalsFloatingWidget.vue?vue&type=template&id=01aedfc4&scoped=true"
import script from "./TotalsFloatingWidget.vue?vue&type=script&lang=js"
export * from "./TotalsFloatingWidget.vue?vue&type=script&lang=js"
import style0 from "./TotalsFloatingWidget.vue?vue&type=style&index=0&id=01aedfc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01aedfc4",
  null
  
)

export default component.exports